module.exports = __webpack_public_path__ + "static/MK3T5137-fea22bb27da2c695c0bf873b2d762ee8.jpg";